import Proxy from './Proxy';

class AlertProxy extends Proxy {
  /**
   * The constructor for the CareplanProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/Alerts', parameters);
  }

  /**
   * Method used to view user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  view(data) {
    return this.submit('post', `${this.endpoint}/list`, data);
  }

  /**
   * Method used to view user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  update(data) {
    return this.submit('patch', `${this.endpoint}/${data.id}`, data);
  }

  /**
   * Resolves one or more alerts.
   *
   * @param {resolution data} data
   */
  resolve(data) {
    return this.submit('post', `${this.endpoint}/resolve`, data);
  }

  /**
   * Fetches resolved notes filtering with patient id and alert date
   *
   * @param {patientId, alertDate to filter resolved notes} param0
   */
  getResolvedNotes(data) {
    return this.submit('post', `${this.endpoint}/resolved`, data);
  }
}

export default AlertProxy;
